import React from 'react';

export default <div className="oneColor" style={{height: '100%'}}>
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 31 39">
    <path fill="#2B328C" fillRule="evenodd" d="M11.611 4.68c0-2.584-2.6-4.68-5.806-4.68S0 2.096 0 4.68v29.641C0 36.905 2.599 39 5.805 39c3.206 0 5.806-2.095 5.806-4.679V4.68zM31 34.321C31 36.905 28.4 39 25.194 39s-5.806-2.095-5.806-4.679V4.68c0-2.584 2.6-4.68 5.806-4.68S31 2.096 31 4.68v29.641z"/>
  </svg>
</div>;
